import Vue from 'vue'
import VueFire from 'vuefire'
import { firestorePlugin } from 'vuefire'
import VueCookie from 'vue-cookie'
import PrismicVue from 'prismic-vue'
import Axios from 'axios'

import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import VuePageTitle from 'vue-page-title'
import App from './App'
import router from './router'
import firebase from 'firebase'
import './components/firebaseinit'

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import VueScrollTo from 'vue-scrollto'



// ..
AOS.init();

Vue.prototype.$http = Axios
Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

// console.log(VueFire);
Vue.use(PrismicVue, {
  endpoint: 'https://molecule.cdn.prismic.io/api/v2',
  linkResolver: linkResolver
});



Vue.use(VueCookie);
Vue.use(firestorePlugin)
Vue.use(VuePageTitle, { router })


Vue.config.productionTip = false

let app
firebase.auth().onAuthStateChanged(user => {
	if(!app) {
		app = new Vue({
		  router,
		  render: h => h(App)
		}).$mount('#app')
	}
})



